import AdvancedQueryLayout from './index.vue'

export default AdvancedQueryLayout
